<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="分类名称" prop="categoryName">
                <a-input v-model="queryParam.categoryName" placeholder="请输入分类名称" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
           <a-col :md="8" :sm="24">
             <a-form-item label="是否推荐" prop="isRecommend">
               <a-select v-model="queryParam.isRecommend" placeholder="请选择是否推荐" allow-clear>
                 <a-select-option :value="1">是</a-select-option>
                 <a-select-option :value="0">否</a-select-option>
               </a-select>
             </a-form-item>
           </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd" v-hasPermi="['dynamic:category:add']">
          <a-icon type="plus" />新增分类
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['dynamic:category:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['dynamic:category:remove']">
          <a-icon type="delete" />删除
        </a-button>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :category-options="categoryOptions"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" 
        :scroll="{x: 1500,y:'calc(100vh - 400px)'}" 
        :columns="columns"
        :data-source="treeData"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :expanded-row-keys="expandedRowKeys"
        :default-expand-all-rows="false"
        @expand="onExpand"
      >
      <span slot="index" slot-scope="text, record, index">
          {{ getIndex(record, index) }} 
        </span>
        <span slot="categoryName" slot-scope="text, record">
          {{ record.categoryName }}
        </span>
        <span slot="picture" slot-scope="text, record">
          <img v-if="record.picture" v-viewer :src="record.picture" style="width: 60px; height: 60px; object-fit: cover; cursor: pointer;" preview="分类图片"/>
          <span v-else style="color: #999;">-</span>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="isRecommend" slot-scope="text, record">
            <a-popconfirm ok-text="是" cancel-text="否" @confirm="confirmRecommendNews(record,record.isRecommend)"
                          @cancel="cancel()">
              <span slot="title">
                <b>{{ record.isRecommend == 1 ? '取消推荐' : '确认推荐' }} </b>?
                </span>
              <a-switch checked-children="是" un-checked-children="否" :checked="record.isRecommend == 1" />
            </a-popconfirm>
        </span>
        <span slot="operation" slot-scope="text, record, index">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['dynamic:category:edit']" style="margin-right: 8px;">
            <a-icon type="edit" />修改
          </a>
          <a @click="handleDelete(record, index)" v-hasPermi="['dynamic:category:remove']" style="color: #ff4d4f;">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listCategory, delCategory, updateCategory, getCategory } from '@/api/dynamic/category'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { handleTree } from '@/utils/ruoyi'

export default {
  name: 'Category',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [], // 原始列表数据
      treeData: [], // 树形数据
      categoryOptions: [], // 分类选项（用于下拉选择）
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      //索引indexs
      indexs: [],
      loading: false,
      // 展开的行keys
      expandedRowKeys: [],
      total: 0,
      current: 1,
      size: 10,
      // 查询参数
      queryParam: {
        categoryName: null,
        isRecommend: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 80,                    
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        {
          title: '分类名称',
          dataIndex: 'categoryName',
          ellipsis: true,
          align: 'left',
          width: 150,
          scopedSlots: { customRender: 'categoryName' },
        },
        {
          title: '图片',
          dataIndex: 'picture',
          ellipsis: true,
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'picture' },
        },
        {
          title: '是否推荐',
          dataIndex: 'isRecommend',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: {customRender: 'isRecommend'}
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
          width: 180
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  methods: {
    confirmRecommendNews(record,isRecommend) {
      updateCategory({id:record.id,categoryName:record.categoryName,isRecommend:isRecommend == 1?0:1}).then(res=>{
        if(res.success){
          this.$message.success("操作成功")
          this.getList()
        }else{
          this.$message.error(res.message)
        }
      })
    },
    /** 取消不做操作 */
    cancel() {
      
    },
    /** 查询动态分类列表 */
    getList () {
      this.loading = true
      // 树形结构需要获取所有数据，然后在前端进行分页
      const params = {
        categoryName: this.queryParam.categoryName,
        isRecommend: this.queryParam.isRecommend
      }
      listCategory(params).then(response => {
        if (response.success && response.data) {
          this.list = response.data
          this.buildTreeData()
          // 构建分类选项（用于下拉选择，不进行过滤和分页）
          this.buildCategoryOptions()
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    /** 构建分类选项（用于下拉选择） */
    buildCategoryOptions () {
      if (!this.list || this.list.length === 0) {
        this.categoryOptions = []
        return
      }
      
      // 检查数据是否已经有children
      const hasChildren = this.list.some(item => item.children && Array.isArray(item.children) && item.children.length > 0)
      
      let treeData = []
      if (hasChildren) {
        // 如果数据已经有children，直接使用
        treeData = this.list.filter(item => {
          const pid = String(item.pid || '0')
          return pid === '0' || pid === ''
        })
        // 处理children
        const processChildren = (nodes) => {
          if (!nodes || nodes.length === 0) return
          nodes.forEach(node => {
            if (node.children === '') {
              delete node.children
            } else if (node.children && Array.isArray(node.children) && node.children.length > 0) {
              processChildren(node.children)
            }
          })
        }
        processChildren(treeData)
      } else {
        // 使用handleTree构建树形结构
        treeData = handleTree(this.list, 'id', 'pid', 'children', '0')
        // 处理空的children
        const processChildren = (nodes) => {
          if (!nodes || nodes.length === 0) return
          nodes.forEach(node => {
            if (node.children === '') {
              delete node.children
            } else if (node.children && Array.isArray(node.children) && node.children.length > 0) {
              processChildren(node.children)
            }
          })
        }
        processChildren(treeData)
      }
      
      this.categoryOptions = treeData
    },
    /** 构建树形数据 */
    buildTreeData () {
      // 如果没有数据，直接返回
      if (!this.list || this.list.length === 0) {
        this.treeData = []
        this.total = 0
        return
      }
      
      // 过滤数据
      let filteredList = [...this.list]
      
      // 根据分类名称过滤
      if (this.queryParam.categoryName) {
        filteredList = filteredList.filter(item => 
          item.categoryName && item.categoryName.includes(this.queryParam.categoryName)
        )
      }
      
      // 根据是否推荐过滤
      if (this.queryParam.isRecommend !== null && this.queryParam.isRecommend !== undefined) {
        filteredList = filteredList.filter(item => 
          item.isRecommend === this.queryParam.isRecommend
        )
      }
      
      // 检查数据是否已经有children（后端可能已经构建了树形结构）
      const hasChildren = filteredList.some(item => item.children && Array.isArray(item.children) && item.children.length > 0)
      
      let treeData = []
      if (hasChildren) {
        // 如果数据已经有children，直接使用，只需要找出根节点
        console.log('数据已有children，直接使用')
        treeData = filteredList.filter(item => {
          const pid = String(item.pid || '0')
          return pid === '0' || pid === ''
        })
        // 确保children属性正确（如果children是空字符串，删除它）
        const processChildren = (nodes) => {
          if (!nodes || nodes.length === 0) return
          nodes.forEach(node => {
            if (node.children === '') {
              delete node.children
            } else if (node.children && Array.isArray(node.children) && node.children.length > 0) {
              processChildren(node.children)
            }
          })
        }
        processChildren(treeData)
      } else {
        // 如果没有children，使用handleTree构建树形结构
        console.log('使用handleTree构建树形结构')
        treeData = handleTree(filteredList, 'id', 'pid', 'children', '0')
        
        // 如果handleTree返回空数组，手动构建
        if (!treeData || treeData.length === 0) {
          console.warn('handleTree返回空数组，手动构建')
          const map = {}
          const roots = []
          
          filteredList.forEach(item => {
            map[String(item.id)] = { ...item, children: [] }
          })
          
          filteredList.forEach(item => {
            const node = map[String(item.id)]
            const pid = String(item.pid || '0')
            if (pid === '0' || pid === '') {
              roots.push(node)
            } else if (map[pid]) {
              map[pid].children.push(node)
            }
          })
          
          treeData = roots
        }
      }
      
      // 处理空的children（handleTree会将没有子节点的children设为空字符串''）
      const processChildren = (nodes) => {
        if (!nodes || nodes.length === 0) return
        nodes.forEach(node => {
          // 如果children是空字符串，删除该属性
          if (node.children === '') {
            delete node.children
          } else if (node.children && Array.isArray(node.children) && node.children.length > 0) {
            // 有子节点，递归处理
            processChildren(node.children)
            // 确保children是数组类型（ant-design-vue需要数组才能显示展开图标）
            if (!Array.isArray(node.children)) {
              node.children = []
            }
          } else if (node.children && !Array.isArray(node.children)) {
            // 如果children不是数组，删除它
            delete node.children
          }
        })
      }
      processChildren(treeData)
      
      // 调试：检查树形数据
      console.log('=== 树形数据构建 ===')
      console.log('原始数据长度:', filteredList.length)
      console.log('树形数据长度:', treeData.length)
      console.log('树形数据:', treeData)
      
      // 检查哪些节点有children
      treeData.forEach((node, index) => {
        if (node.children && Array.isArray(node.children) && node.children.length > 0) {
          console.log(`节点 ${index + 1} (${node.categoryName}) 有 ${node.children.length} 个子节点`)
          console.log('  children:', node.children)
        } else {
          console.log(`节点 ${index + 1} (${node.categoryName}) 没有子节点, children:`, node.children)
        }
      })
      
      // 对根节点进行分页
      const startIndex = (this.queryParam.pageNum - 1) * this.queryParam.pageSize
      const endIndex = startIndex + this.queryParam.pageSize
      const paginatedRoots = treeData.slice(startIndex, endIndex)
      
      // 更新总数（根节点数量）
      this.total = treeData.length
      this.current = this.queryParam.pageNum
      this.size = this.queryParam.pageSize
      
      // 确保树形数据正确
      this.treeData = paginatedRoots
      // 重置展开状态
      this.expandedRowKeys = []
    },
    /** 获取序号 - 递归计算 */
    getIndex (record, index) {
      // 对于树形表格，序号计算比较复杂
      // 这里简化处理，使用index+1
      // 如果需要更准确的序号，可以在构建树时添加序号属性
      return index + 1
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        categoryName: null,
        isRecommend: null,
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },
    /** 分页大小改变 */
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      // 重新构建树形数据（会进行分页）
      this.buildTreeData()
    },
    /** 分页改变 */
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize || this.queryParam.pageSize
      // 重新构建树形数据（会进行分页）
      this.buildTreeData()
    },
    /** 展开/收起单个节点 */
    onExpand (expanded, record) {
      if (expanded) {
        // 展开：添加该节点的key
        if (!this.expandedRowKeys.includes(record.id)) {
          this.expandedRowKeys = [...this.expandedRowKeys, record.id]
        }
      } else {
        // 收起：移除该节点及其所有子节点的key
        const removeKeys = [record.id]
        const getChildrenKeys = (node) => {
          if (node.children && Array.isArray(node.children) && node.children.length > 0) {
            node.children.forEach(child => {
              removeKeys.push(child.id)
              getChildrenKeys(child)
            })
          }
        }
        getChildrenKeys(record)
        this.expandedRowKeys = this.expandedRowKeys.filter(key => !removeKeys.includes(key))
      }
    },
    /** 获取所有有子节点的keys（递归） */
    getAllExpandableKeys (nodes) {
      let keys = []
      nodes.forEach(node => {
        if (node.children && node.children.length > 0) {
          keys.push(node.id)
          keys = keys.concat(this.getAllExpandableKeys(node.children))
        }
      })
      return keys
    },
    /** 展开全部 */
    expandAll () {
      this.expandedRowKeys = this.getAllExpandableKeys(this.treeData)
    },
    /** 收起全部 */
    collapseAll () {
      this.expandedRowKeys = []
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row, index) {
      var that = this
      const ids = row ? [row.id] : this.ids
      const indexs = row ? [index + 1] : this.selectedRowKeys.map((key, idx) => {
        const record = that.treeData.find(item => item.id === key)
        return record ? that.treeData.indexOf(record) + 1 : idx + 1
      })
      
      this.$confirm({
        title: '确认删除所选中数据?',
        content: ids.length === 1 ? `确认删除序号为 ${indexs[0]} 的数据?` : `确认删除序号为 ${indexs.join(',')} 的数据?`,
        onOk() {
          let data = ids.map(id => ({ id }))
          return delCategory(data)
            .then((res) => {
              if(res.success){
                that.onSelectChange([], [])
                that.getList()
                that.$message.success('删除成功', 3)
              }else{
                that.$message.error(res.message, 3)
              }
          })
        },
        onCancel () {
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd () {
      this.$refs.createForm.handleAdd()
    }
  }
}
</script>

<style scoped>
/* 调整表格单元格的内边距，减少列之间的间距 */
::v-deep .ant-table td {
  padding: 12px 8px !important;
}

::v-deep .ant-table th {
  padding: 12px 8px !important;
}

/* 调整图片列的间距 */
::v-deep .ant-table-tbody > tr > td[data-column-key="picture"] {
  padding: 8px !important;
}
</style>
